var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('grid-picker',{staticStyle:{"width":"580px","height":"360px"},attrs:{"data":_vm.fakeCountries,"key-map":_vm.fakeKeyMap,"headlines":_vm.headlines},on:{"changed:data":_vm.change}})}
var staticRenderFns = []

export { render, staticRenderFns }